import React from "react";
import FooterLogo from "../../Images/Footer-logo.svg";
import FbLogo from "../../Images/fb-logo.svg";
import InstaLogo from "../../Images/Insta-logo.svg";
import { Link } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

function Footer() {
  return (
    <div
      className="container footer-bg"
      style={{ marginTop: "3rem", paddingTop: "6rem", paddingBottom: "4rem" }}
    >
      <div className="footer-display  px-5">
        <div className="">
          <LazyLoadImage effect="blur" className="" src={FooterLogo} alt="" />
          <h5 className="py-4 footer-text">
            Redefining style with contemporary, custom-made fashion for every
            occasion.
          </h5>
          <div className="py-3">
            <a target="_blank" href="https://www.facebook.com/latthransoft">
              <span>
                <svg
                  className="social-hover"
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21 20.25H24.75L26.25 14.25H21V11.25C21 9.705 21 8.25 24 8.25H26.25V3.21C25.761 3.1455 23.9145 3 21.9645 3C17.892 3 15 5.4855 15 10.05V14.25H10.5V20.25H15V33H21V20.25Z"
                    className="svg-path"
                  />
                </svg>
              </span>
            </a>
            <a target="_blank" href="https://www.instagram.com/lathransoft/">
              <span className="px-3">
                <svg
                  className="social-hover"
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    className="svg-path"
                    d="M19.5419 3C21.2294 3.0045 22.0859 3.0135 22.8254 3.0345L23.1164 3.045C23.4524 3.057 23.7839 3.072 24.1844 3.09C25.7804 3.165 26.8694 3.417 27.8249 3.7875C28.8149 4.1685 29.6489 4.6845 30.4829 5.517C31.2456 6.26684 31.8358 7.17388 32.2124 8.175C32.5829 9.1305 32.8349 10.2195 32.9099 11.817C32.9279 12.216 32.9429 12.5475 32.9549 12.885L32.9639 13.176C32.9864 13.914 32.9954 14.7705 32.9984 16.458L32.9999 17.577V19.542C33.0036 20.6361 32.9921 21.7302 32.9654 22.824L32.9564 23.115C32.9444 23.4525 32.9294 23.784 32.9114 24.183C32.8364 25.7805 32.5814 26.868 32.2124 27.825C31.8369 28.8267 31.2466 29.7339 30.4829 30.483C29.7328 31.2455 28.8259 31.8356 27.8249 32.2125C26.8694 32.583 25.7804 32.835 24.1844 32.91C23.8285 32.9268 23.4725 32.9418 23.1164 32.955L22.8254 32.964C22.0859 32.985 21.2294 32.9955 19.5419 32.9985L18.4229 33H16.4594C15.3648 33.0038 14.2702 32.9923 13.1759 32.9655L12.8849 32.9565C12.5288 32.943 12.1728 32.9275 11.8169 32.91C10.2209 32.835 9.13189 32.583 8.17489 32.2125C7.17389 31.8366 6.26721 31.2463 5.51839 30.483C4.75496 29.7334 4.16423 28.8263 3.78739 27.825C3.41689 26.8695 3.16489 25.7805 3.08989 24.183C3.07318 23.8271 3.05818 23.4711 3.04489 23.115L3.03739 22.824C3.00975 21.7302 2.99725 20.6361 2.99989 19.542V16.458C2.9957 15.3639 3.0067 14.2698 3.03289 13.176L3.04339 12.885C3.05539 12.5475 3.07039 12.216 3.08839 11.817C3.16339 10.2195 3.41539 9.132 3.78589 8.175C4.16256 7.17286 4.75447 6.26554 5.51989 5.517C6.26853 4.75421 7.1746 4.16398 8.17489 3.7875C9.13189 3.417 10.2194 3.165 11.8169 3.09C12.2159 3.072 12.5489 3.057 12.8849 3.045L13.1759 3.036C14.2697 3.00935 15.3638 2.99785 16.4579 3.0015L19.5419 3ZM17.9999 10.5C16.0108 10.5 14.1031 11.2902 12.6966 12.6967C11.2901 14.1032 10.4999 16.0109 10.4999 18C10.4999 19.9891 11.2901 21.8968 12.6966 23.3033C14.1031 24.7098 16.0108 25.5 17.9999 25.5C19.989 25.5 21.8967 24.7098 23.3032 23.3033C24.7097 21.8968 25.4999 19.9891 25.4999 18C25.4999 16.0109 24.7097 14.1032 23.3032 12.6967C21.8967 11.2902 19.989 10.5 17.9999 10.5ZM17.9999 13.5C18.5908 13.4999 19.176 13.6162 19.722 13.8423C20.268 14.0683 20.7642 14.3997 21.1821 14.8175C21.6 15.2353 21.9316 15.7313 22.1578 16.2772C22.384 16.8232 22.5005 17.4083 22.5006 17.9993C22.5007 18.5902 22.3844 19.1754 22.1584 19.7214C21.9323 20.2674 21.6009 20.7635 21.1832 21.1814C20.7654 21.5994 20.2693 21.9309 19.7234 22.1572C19.1775 22.3834 18.5923 22.4999 18.0014 22.5C16.8079 22.5 15.6633 22.0259 14.8194 21.182C13.9755 20.3381 13.5014 19.1935 13.5014 18C13.5014 16.8065 13.9755 15.6619 14.8194 14.818C15.6633 13.9741 16.8079 13.5 18.0014 13.5M25.8764 8.25C25.3791 8.25 24.9022 8.44754 24.5506 8.79917C24.1989 9.15081 24.0014 9.62772 24.0014 10.125C24.0014 10.6223 24.1989 11.0992 24.5506 11.4508C24.9022 11.8025 25.3791 12 25.8764 12C26.3737 12 26.8506 11.8025 27.2022 11.4508C27.5538 11.0992 27.7514 10.6223 27.7514 10.125C27.7514 9.62772 27.5538 9.15081 27.2022 8.79917C26.8506 8.44754 26.3737 8.25 25.8764 8.25Z"
                    fill="#DFFFBF"
                  />
                </svg>
              </span>
            </a>
          </div>
        </div>
        <div className="footer-option-margin">
          <p
            className=" py-1 Cormorant-font fw-bold "
            style={{ fontSize: "20px" }}
          >
            Quick Links
          </p>
          <Link className=" py-1 footer-hover-color" to="/explore-all">
            {" "}
            <p> Explore All</p>
          </Link>
          <Link className=" py-1 footer-hover-color" to="/men">
            {" "}
            <p>Men</p>
          </Link>
          <Link className=" py-1 footer-hover-color" to="/women">
            {" "}
            <p>Women</p>
          </Link>
          <Link className="footer-hover-color" to="/contact-us">
            {" "}
            <p>Contact Us</p>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Footer;
